import React from 'react';
import styles from './smart-records-panel.module.css';
import promoImage from '../../assets/images/ahaShapesPromo.png';
import classNames from 'classnames';
import { PROMO_LINK } from './SmartRecordsPanel';
import trackEvent from '../../utils/analytics';

const Promo: React.FC = () => {
  return (
    <div
      className={classNames(
        styles.panelItem,
        styles.panelItemFull,
        styles.promoPanelItem
      )}
      data-testid='smart-records-panel-promo'
    >
      <div className={styles.promo}>
        <img src={promoImage} className='mb-5' />
        <span className='h-500'>Create a detailed plan</span>
        <span className={classNames('t-100', styles.promoSubheader)}>
          Convert Aha! shapes into detailed records in Aha! Roadmaps. Use the
          world&apos;s #1 tool for building products to bring your plans to
          life.
        </span>
        <a
          href={PROMO_LINK}
          target='_blank'
          rel='noreferrer'
          onClick={() => {
            trackEvent('Feature-7366764257171025062', 'User views promotion', {
              'Upgrade location': 'Whiteboards side panel convert',
              'Promotion product': 'Roadmaps',
            });
          }}
        >
          <aha-button kind='success' type='button'>
            Try Aha! Roadmaps free
          </aha-button>
        </a>
      </div>
    </div>
  );
};

export default Promo;
